'use client'

import { useEffect, useMemo, useState } from 'react'
import { getCheckoutVisibleItems } from '@/helpers/checkout/checkout-visible-items'
import { useOrder } from '@/hooks/use-order-store'

export function CountItensCart() {
  const { order, isLoading } = useOrder()
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  const quantityProductOrder = useMemo(
    () => getCheckoutVisibleItems(order?.items).length,
    [order?.items]
  )

  if (!mounted || quantityProductOrder === 0 || isLoading) {
    return null
  }

  return (
    <span
      className="-right-2 absolute select-none rounded-full bg-yellow-300 px-1.5 py-0.5 font-bold text-[#171717] text-xs"
      title={`${quantityProductOrder} itens no carrinho`}
    >
      {quantityProductOrder}
    </span>
  )
}
